import React from "react";
import Card from "react-bootstrap/Card";
import { ImAddressBook, ImAidKit, ImAppleinc, ImArrowRight, ImBubble, ImInfo, ImInstagram, ImPointRight, ImSpotify } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Dip Mandal </span>
            from <span className="purple"> Kolkata, India.</span>
            <br />I am a student pursuing Masters Of Computer Application (MCA)
             in RCC Institute of Information Technology and I have completed my 
             BCA degree from Techno India College Of Technology(Formerly Known as Techno International NewTown).
            <br />
            <br />
            Apart from coding, some other activities that I love to do :-
          </p>
          <ul>
            <li className="about-activity">
              <ImArrowRight /> Playing Games like Cricket,Caram,Volley Ball etc.
            </li>
            <li className="about-activity">
              <ImArrowRight /> Writting Tech Blogs & Music,Video Editing.
            </li>
            <li className="about-activity">
              <ImArrowRight /> Travelling
              </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Always be different & difficult from others!"{" "}
          </p>
          <footer className="blockquote-footer">Dip</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
